import { invokeApi } from "../../bl_libs/invokeApi";

export const conversations_list_api = async (type, signal = null) => {
  const requestObj = {
    path: `api/conversations?type=${type}`,
    method: "GET",
    signal,
  };
  return invokeApi(requestObj);
};

export const unread_conversations_list_api = async (signal = null) => {
  const requestObj = {
    path: `api/conversations/unread_conversations`,
    method: "GET",
    signal,
  };
  return invokeApi(requestObj);
};
